import { Card, CardContent, Typography, Box } from "@mui/material";

export default function DashboardCardsUI({
  title,
  discription,
  img,
  bajajdate,
}) {
  // console.log("bajajdate: ", bajajdate);
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fafafa !important",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.05)", // Increase size on hover
          boxShadow: "0px 0px 5px 0px #4a2a7d", // Add shadow on hover
        },
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pt: "10px",
        }}
      >
        <img
          src={img}
          alt="logo"
          style={{ maxHeight: "60px", maxWidth: "60px" }}
        />
      </Box>

      <CardContent sx={{ textAlign: "center", p: "0px" }}>
        <Typography variant="body2" color="text.secondary">
          {/* {bajajdate} */}
          {title == "Bajaj Total" && bajajdate ? `As of (${bajajdate})` : ""}
        </Typography>
        <Typography
          variant="h6"
          component="div"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap", // or use line-clamp to restrict to a fixed number of lines
          }}
        >
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {discription}
        </Typography>
      </CardContent>
    </Card>
  );
}
